const MODULE_NAME = 'IsoModule';

export const SET_ISO_NAMES = `${MODULE_NAME}/SET_ISO_NAMES`;
export const LOCAL_SET_ISO_NAMES = 'SET_ISO_NAMES';
export const LOCAL_SET_ISO_GRADES = 'SET_ISO_GRADES';
export const LOCAL_SET_ISO_VALUES = 'SET_ISO_VALUES';
export const LOCAL_CLEAR_ISO_GRADES = 'CLEAR_ISO_VALUES';
